module.exports = __webpack_public_path__ + "static/maya-2b4221823e54573f0f8d65095abdf005.jpg";